<template>
  <div>
    <b-modal
      ref="map-modal"
      id="map-modal"
      :title="mapModalTitle"
      size="lg"
      hide-footer
      @shown="onMapShown"
      @hidden="destroyMap"
    >
      <div v-if="mapLoading" class="text-center py-5">
        <b-spinner variant="primary" />
        <p class="mt-2 text-muted">Obteniendo ubicación...</p>
      </div>
      <div v-else-if="mapError" class="text-center py-4">
        <p class="text-danger">{{ mapError }}</p>
      </div>
      <div v-else>
        <p v-if="mapLocationLabel" class="text-muted small mb-2">
          {{ mapLocationLabel }}
        </p>
        <div id="map-canvas" style="height: 420px; width: 100%;"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import environment from "../../env";
import geolocationService from "../services/geolocation";

const PRIVATE_IP_REGEX = /^(10\.|172\.(1[6-9]|2\d|3[01])\.|192\.168\.|127\.|169\.254\.|100\.(6[4-9]|[7-9]\d|1[01]\d|12[0-7])\.|::1$|fc00:|fd)/;
const GOOGLE_MAPS_API_URL = "https://maps.googleapis.com/maps/api/js";

export default {
  data() {
    return {
      mapLoading: false,
      mapError: null,
      mapLocationLabel: "",
      mapModalTitle: "Ubicación IP",
      mapInstance: null,
      mapModalReady: false,
      pendingMapInit: null,
    };
  },
  methods: {
    async showIpLocation(ip, name) {
      this.mapError = null;
      this.mapLocationLabel = "";
      this.mapModalTitle = `Ubicación de ${name} (${ip})`;
      this.mapLoading = true;
      this.$refs["map-modal"].show();

      const ipv4Mapped = ip.match(/^::ffff:(\d+\.\d+\.\d+\.\d+)$/i);
      if (ipv4Mapped) ip = ipv4Mapped[1];

      if (PRIVATE_IP_REGEX.test(ip)) {
        this.mapLoading = false;
        this.mapError = `La IP ${ip} es privada o local y no puede geolocalizarse.`;
        return;
      }

      try {
        const data = await geolocationService.getIpLocation(ip);
        this.mapLocationLabel = `${data.city || ""}, ${data.region || ""}, ${data.country_name || ""} — ${data.org || ""}`.replace(/^,\s*|,\s*$/g, "").trim();
        this.mapLoading = false;
        if (this.mapModalReady) {
          this.$nextTick(() => this.initMap(data.latitude, data.longitude, name, ip));
        } else {
          this.pendingMapInit = { lat: data.latitude, lng: data.longitude, name, ip };
        }
      } catch (error) {
        this.mapError = error.message || "Error al consultar el servicio de geolocalización.";
        this.mapLoading = false;
      }
    },

    initMap(lat, lng, name, ip) {
      const apiKey = environment.environment.googleMapsApiKey;
      const init = () => {
        const container = document.getElementById("map-canvas");
        if (!container) return;
        this.mapInstance = new window.google.maps.Map(container, {
          center: { lat, lng },
          zoom: 11,
        });
        new window.google.maps.Marker({
          position: { lat, lng },
          map: this.mapInstance,
          title: `${name} (${ip})`,
        });
        window.google.maps.event.trigger(this.mapInstance, "resize");
        this.mapInstance.setCenter({ lat, lng });
      };

      if (window.google && window.google.maps) {
        setTimeout(init, 50);
        return;
      }

      const script = document.createElement("script");
      script.src = `${GOOGLE_MAPS_API_URL}?key=${apiKey}`;
      script.async = true;
      script.defer = true;
      script.onload = init;
      document.head.appendChild(script);
    },

    onMapShown() {
      this.mapModalReady = true;
      if (this.pendingMapInit) {
        const p = this.pendingMapInit;
        this.pendingMapInit = null;
        this.$nextTick(() => this.initMap(p.lat, p.lng, p.name, p.ip));
      }
    },

    destroyMap() {
      this.mapInstance = null;
      this.mapModalReady = false;
      this.pendingMapInit = null;
    },
  },
};
</script>
